import * as R from 'ramda';
import { Endpoints } from '../../../core/api/endpoints';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../../../core/api/module';
import { ActionType } from '../../../core/redux/actionType';
import { CompetencyAndQuestion } from '../models';


const KEY_ACTION = ActionType.GetCompetenciesAndQuestionsRequest;
const ACTIONS    = [
  ActionType.GetCompetenciesAndQuestionsRequest,
  ActionType.GetCompetenciesAndQuestionsResponse,
  ActionType.GetCompetenciesAndQuestionsError,
];


type Payload = CompetencyAndQuestion[];

type Meta = {
  projectId: number;
};


/**
 * Dispatch this action to get the competencies and questions used to build the feedback survey
 */
export const getCompetenciesAndQuestionsAction = (projectId: number) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.GetCompetenciesAndQuestions,
  headers:  { 'content-type': 'application/json' },
  body:     state => JSON.stringify({ projectId, languageId: state.locale.lang.languageId }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId }),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assocPath(['competenciesAndQuestions', `${action.meta.projectId}`], payload, successState);
};


export const getCompetenciesAndQuestionsReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
